import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n, getI18nBase } from 'client/i18n'
import CharityCard from 'components/common/charity_card'
import DateInputBox from 'components/common/date_input_box'
import CrowdFundingCoverImage from 'components/crowdfunding_cover_image'
import CrowdFundingPreview from 'components/pages/crowdfunding/crowdfunding_preview'
import StandardDialog from 'components/common/standard_dialog'
import {
  DESCRIPTION_ROWS,
  CROWDFUNDING_DESCRIPTION_LENGTH,
} from 'shared/lengths'
import styles from './edit_main_cf.less'
import { appendPath } from 'lib/route_utils'
import { domOnlyProps } from 'lib/form_utils'
import { getFormError } from 'lib/validators'
import { formatDateShort, getDefaultCurrencyCode } from 'client/griffin'
import {
  TextInput,
  HeadingText,
  Dialog,
  Button,
  DropdownMenu,
  TextArea,
  BodyText,
} from '@paypalcorp/pp-react'
import { trackClick, trackImpression } from 'lib/fpti_analytics'
import _get from 'lodash/get'
import {
  INVALID_IMAGE,
  POOL_TYPE,
  TOAST_NOTIFICATIONS,
} from 'shared/shared_consts'
import CurrencyInputBox from 'components/common/currency_input'
import { hoursFromToday } from 'shared/helpers/datetime_helpers'
import PrivateEditForm from './partials/privateEditForm'
import { hubPageUrl } from '../../../../lib/campaign_url'
import DeleteReview from '../delete_error/delete_review'
import DeleteFundraiser from './partials/delete_fundraiser'

const i18n = getI18n('components/edit_glimpse/edit_main')
const i18nBase = getI18nBase('components/edit_glimpse/edit_main')
const i18nGoalAmount = getI18n('components/pages/crowdfunding/pool_basics')

const getGoalAmountTitle = (charity, formattedMaxGoalAmount) => {
  if (charity) {
    return i18nGoalAmount('goal_amount_title_gnc')
  }
  return i18nBase('amount_cf', {
    maxGoalAmount: formattedMaxGoalAmount,
  })
}
class EditMain extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    ended: PropTypes.bool,
    showDelete: PropTypes.bool,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onSave: PropTypes.func,
    handleSubmit: PropTypes.func,
    isAndroid: PropTypes.bool,
    category: PropTypes.string,
    categoryList: PropTypes.array,
    router: PropTypes.object,
    campaign: PropTypes.object,
    stepRef: PropTypes.func,
    dirty: PropTypes.bool,
    formattedMaxGoalAmount: PropTypes.string,
    charity: PropTypes.object,
    onToggleToast: PropTypes.func,
    timeZone: PropTypes.string,
    currency: PropTypes.string,
    campaignId: PropTypes.string,
    showCategoryInput: PropTypes.boolean,
    onDelete: PropTypes.func,
  }

  state = {
    charCount: 0,
    isOpen: false,
    editedCampagin: this.props.campaign,
    showBackDialog: false,
    callback: null,
    showDeleteReview: false,
  }

  handleKeyUp = e => {
    const content = e.target.value.length
    this.setState({
      charCount: content,
    })
  }
  handleModalClick = e => {
    e.preventDefault()
    this.trackEvents('dw_giving_edit_fundraiser_preview_pressed')
    this.setData()
  }

  handleModalClose = () => {
    this.setState({ isOpen: false })
    trackClick({
      clickName: 'dw_giving_fundraiser_preview_dismiss_pressed',
      data: {
        event_name: 'dw_giving_fundraiser_preview_dismiss_pressed',
        dismiss_method: 'close',
      },
    })
    this.trackEvents('dw_giving_fundraiser_preview_dismiss_pressed')
  }

  setData() {
    const {
      fields: {
        poolName,
        endDate,
        goalAmount,
        category,
        description,
        backgroundImage,
        backgroundImageFilename,
        backgroundPan,
        gradientColor,
      },
    } = this.props
    const newCampaign = Object.assign(this.state.editedCampagin, {
      goal: goalAmount.value || 0,
      category: category.value,
      description: description.value,
      end_date: endDate.value,
      title: poolName.value,
      event_name: poolName.value,
      gradient_color: gradientColor.value,
      background_image: backgroundImage.value,
      background_image_filename: backgroundImageFilename.value,
      background_pan: backgroundPan.value,
    })
    this.setState({
      editedCampagin: newCampaign,
      isOpen: true,
    })
    trackImpression({
      event_name: 'dw_giving_fundraiser_preview_screen_shown',
    })
  }

  handleSubmit = () => {
    const saveEvent = this.state.showBackDialog
      ? 'dw_giving_quit_editing_fundraiser_save_pressed'
      : 'dw_giving_edit_fundraiser_save_pressed'
    this.trackEvents(saveEvent)
    this.setState({ showBackDialog: false, callback: null })

    const { value, initialValue } = this.props.fields.backgroundImage || {}
    const request = {
      poolName: this.props.fields.poolName.value,
      endDate: this.props.fields.endDate.value,
      goalAmount: parseInt(this.props.fields.goalAmount.value || 0),
      category: this.props.fields.category.value,
      description: this.props.fields.description.value,
      gradientColor: this.props.fields.gradientColor.value,
      backgroundImage: value,
      backgroundImageFilename:
        value === initialValue
          ? ''
          : this.props.fields.backgroundImageFilename.value,
      backgroundPan: this.props.fields.backgroundPan.value,
      isExpired: hoursFromToday(new Date(this.props.campaign.end_date)) <= 0,
    }

    return this.props
      .onSave(request)
      .then(() => {
        this.editBack()
        this.props.onToggleToast(TOAST_NOTIFICATIONS.EDIT_SUCCESS)
      })
      .catch(err => {
        if (err.error === INVALID_IMAGE) {
          this.props.router.push({
            pathname: appendPath(location.pathname, 'manage/error'),
          })
          return
        }
        this.props.router.push({
          pathname: appendPath(location.pathname, 'error'),
          state: { updateData: err.updateData },
        })
      })
  }

  componentDidMount() {
    if (this.props.stepRef) {
      this.props.stepRef(this)
    }
  }

  editBack = () => {
    const { params: { hideBack = false } = {} } = this.props.router
    if (hideBack) {
      this.props.router.push({
        pathname: '/pools',
        state: { reloadTransactions: false, campaignId: this.props.campaignId },
      })
    } else {
      this.props.router.goBack()
    }
  }

  confirmNavigation = callback => {
    this.trackEvents('dw_giving_edit_fundraiser_quit_pressed')
    if (this.props.dirty) {
      this.setState({ showBackDialog: true, callback })
      trackImpression({
        event_name: 'dw_giving_quit_editing_fundraiser_screen_shown',
      })
    } else {
      this.editBack()
    }
  }

  handleDialogClose = () => {
    this.setState({ showBackDialog: false })
  }

  handleDeleteOk = () => {
    this.trackEvents('dw_giving_delete_fundraiser_confirm_pressed')
    this.props
      .onDelete()
      .then(() => {
        location.href = hubPageUrl()
      })
      .catch(err => {
        this.props.router.push({
          pathname: appendPath(location.pathname, 'delete/error'),
          state: { updateData: err },
        })
      })
  }

  handleQuit = () => {
    this.trackEvents('dw_giving_quit_editing_fundraiser_without_save_pressed')
    this.editBack()
    this.setState({ showBackDialog: false, callback: null })
  }

  trackEvents = eventName => {
    trackClick({
      clickName: eventName,
      data: {
        event_name: eventName,
      },
    })
  }

  render() {
    const {
      fields: {
        poolName,
        goalAmount,
        endDate,
        category,
        description,
        anyInactiveFieldsTouchedWithError,
      },
      charity,
      formattedMaxGoalAmount,
      timeZone,
      currency,
      showCategoryInput,
      campaign: { category_image: categoryImage },
      campaignId,
      handleSubmit,
    } = this.props

    if (this.state.showDeleteReview) {
      return (
        <DeleteReview
          data-testid="edit_main_cf__delete-review"
          campaignId={campaignId}
          onDelete={this.handleDeleteOk}
        />
      )
    }

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        {this.state.showBackDialog && (
          <StandardDialog
            size="medium"
            title={i18n('dirty_dialog_title_cf')}
            subtitle={i18n('dirty_dialog_subtitle_cf')}
            closeButtonTitle={i18n('quit_editing')}
            okButtonTitle={i18n('save_changes')}
            onClose={this.handleDialogClose}
            onOk={this.handleSubmit}
            onQuit={this.handleQuit}
            iconName="logout"
          />
        )}

        <HeadingText size="lg" styleName="title">
          {i18n('edit_title_cf')}
        </HeadingText>
        {charity && (
          <>
            <div styleName="charity-header">{i18n('charity')}</div>
            <CharityCard charity={charity} />
            <div styleName="charity-subtitle">{i18n('charity_subtitle')}</div>
          </>
        )}
        <BodyText strong>{i18n('detail_title_cf')}</BodyText>
        {this.props.ended && (
          <div styleName="ended-title">
            {i18n('ended', {
              endDate: formatDateShort(endDate.value),
            })}
          </div>
        )}

        {this.props.campaign.type === POOL_TYPE.PRIVATE ? (
          <PrivateEditForm
            campaign={this.props.campaign}
            endDate={endDate}
            currency={currency}
            poolName={poolName}
            goalAmount={goalAmount}
            formattedMaxGoalAmount={formattedMaxGoalAmount}
          />
        ) : (
          <>
            <div styleName="textbox-wrapper">
              <TextInput
                id={poolName.name}
                label={i18nBase('name_cf')}
                dataNemo="your-pool-name"
                {...domOnlyProps(poolName)}
                disabled={!this.props.campaign.can_chip_in}
                errorText={getFormError(poolName)}
                data-testid="edit-name"
              />
            </div>
            <div styleName="textbox-wrapper">
              <CurrencyInputBox
                id={goalAmount.name}
                label={getGoalAmountTitle(charity, formattedMaxGoalAmount)}
                dataNemo="goal-amount"
                disableCents={true}
                disabled={!this.props.campaign.can_chip_in}
                errorText={getFormError(goalAmount)}
                currencyCode={currency || getDefaultCurrencyCode()}
                {...goalAmount}
                dataTestId="edit-amount"
              />
            </div>
            <div styleName="textbox-wrapper">
              <DateInputBox
                id={endDate.name}
                label={i18nBase('end_date_cf')}
                dataNemo="date-pool-ends"
                errorText={getFormError(endDate)}
                disabled={!this.props.campaign.can_chip_in}
                {...endDate}
                timeZone={timeZone}
                useEndOfDay={false}
                dataTestId="edit-end-date"
              />
            </div>
          </>
        )}
        <BodyText strong styleName="detail-title">
          {i18n('about_titile_cf')}
        </BodyText>
        {showCategoryInput && (
          <div styleName="category">
            <DropdownMenu
              label={_get(i18n('category'), 'props.children', i18n('category'))}
              dataNemo="pool-category"
              options={this.props.categoryList}
              value={category.value}
              onChange={event => category.onChange(event.target.value)}
              data-testid="edit-category"
              disabled={!this.props.campaign.can_chip_in}
            />
          </div>
        )}
        <div styleName="description-container">
          <div styleName="textbox-wrapper">
            <TextArea
              {...domOnlyProps(description)}
              id={description.name}
              dataNemo="about-pool-description"
              minRows={DESCRIPTION_ROWS}
              label={i18n('description_cf')}
              showCharacterCounter={true}
              maxCharacters={CROWDFUNDING_DESCRIPTION_LENGTH}
              errorText={getFormError(description)}
              data-testid="edit-description"
            />
          </div>
        </div>
        {!this.props.isAndroid && (
          <>
            <BodyText strong styleName="detail-title">
              {i18n('photo_titile_cf')}
            </BodyText>
            <div styleName="uploader">
              <CrowdFundingCoverImage
                showPreviewComponent={true}
                fields={this.props.fields}
                categoryImage={categoryImage}
              />
            </div>
          </>
        )}
        {this.props.showDelete && (
          <DeleteFundraiser
            onDeleteClick={this.handleDeleteOk}
            showDeleteReviewModal={() =>
              this.setState({ showDeleteReview: true })
            }
            charity={charity}
            campaign={this.props.campaign}
            date-testid="edit_main_cf-delete-link"
          />
        )}
        <Button
          data-nemo="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
          data-testid="edit-btn-save"
        >
          {i18n('save_cf')}
        </Button>
        <Button
          onClick={this.handleModalClick}
          styleName="btn"
          disabled={anyInactiveFieldsTouchedWithError}
          data-nemo="preview-next"
          secondary
        >
          {i18n('preview_cf')}
        </Button>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.handleModalClose}
          styleName="modal"
          action={
            <HeadingText size="md" styleName="modal_title">
              {i18n('preview_cf')}
            </HeadingText>
          }
        >
          <CrowdFundingPreview
            isEdit={true}
            editedCampaign={this.state.editedCampagin}
          />
        </Dialog>
      </form>
    )
  }
}

export default cssModules(EditMain, styles)
